<template>
  <div class="reset">
    <password-reset-form
      title="Password Reset Form"
      :status-message="updateMessage"
      @save="handlePasswordChange($event)"
    />
  </div>
</template>

<script>
import PasswordResetForm from '@/app/components/PasswordResetForm';
import { helpService } from '../help.service';
export default {
  components: {
    PasswordResetForm
  },
  data() {
    return {
      updateMessage: null,
      passwordChangeCode: null
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.passwordChangeCode = val.params.code;
      }
    }
  },
  mounted() {
    if (this.$route.params.code) {
      this.passwordChangeCode = this.$route.params.code;
    }
  },
  methods: {
    async handlePasswordChange(evt) {
      evt.code = this.passwordChangeCode;
      const result = await helpService.changePassword(evt);
      if (result.text === 'success') {
        this.updateMessage = this.$t('app.help.passwordChangeSuccess');
      } else {
        this.updateMessage = this.$t('app.help.passwordChangeError');
      }
    }
  }
};
</script>

<style>
.reset {
  display: flex;
  justify-content: center;
}
</style>
